import { Progress } from "@/shared/feedback/progress";
import { DeleteButton, DocumentButton } from "@/shared/form/button";
import { UploadResponseFile } from "@/shared/form/upload/model/types";
import { UploadFile } from "antd/lib";

export function FileListItem({
  file,
  actions,
  disabled,
}: {
  disabled?: boolean;
  file: UploadFile<UploadResponseFile>;
  actions: {
    remove: () => void;
  };
}) {
  return (
    <div className="flex items-center space-x-2">
      <div>
        {file.status === "uploading" && (
          <Progress
            percent={Math.round(file.percent ?? 0)}
            size={[150, 4]}
            status="normal"
          />
        )}
        {file.response !== undefined && "link" in file.response && (
          <DocumentButton
            disabled={false} // If parent form is disabled, don't allow reading document, so need to explicitly pass disabled={false} to see documents
            className="!px-0"
            file={{
              temporaryLink: file.response.temporaryLink ?? file.response.link,
              fileName: file.name,
            }}
            name={file.name}
          />
        )}
      </div>
      <div>
        <DeleteButton
          size="small"
          type="text"
          onClick={actions.remove}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
